/** Ecranul pentru cineva din organizație care deschide un proiect fără să aibă
 *  acces la el.
 *
 *  Înainte, serverul răspundea 404 la fel ca pentru un id inventat, iar
 *  interfața desena mai departe carcasa proiectului: bara de discipline, filele
 *  goale, „Modelul 3D apare după rularea lanțului". Omul primea un ecran care
 *  arată stricat, nu unul care spune ce s-a întâmplat și ce are de făcut.
 *
 *  Ecranul ăsta ține locul ÎNTREGII pagini de proiect, nu al unei file: refuzul
 *  e al proiectului, deci n-are sens să poți umbla prin taburile lui.
 */
import { useT, useTx } from "../i18n";
import type { Administrator } from "./rol";

export default function FaraAcces(
  { proiect, organizatie, administratori }:
  { proiect?: string; organizatie?: string; administratori: Administrator[] },
) {
  const t = useT();
  const tx = useTx();
  return (
    <div className="fara-acces">
      <div className="card fara-acces-cutie">
        <h1>{t("fara_acces.titlu")}</h1>
        <p className="note">
          {proiect ? tx("fara_acces.exista_numit", { proiect })
                   : t("fara_acces.exista")}
          {organizatie ? t("fara_acces.in_org", { organizatie }) : null}
          {t("fara_acces.explicatie")}
        </p>

        {administratori.length > 0 && (
          <>
            <div className="fara-acces-titlu">{t("fara_acces.cine_poate")}</div>
            <ul className="fara-acces-lista">
              {administratori.map((a) => (
                <li key={a.email}>
                  <span>{a.name || a.email}</span>
                  {/* `mailto` cu subiectul completat: nu e o „cerere" pe care o
                      vede cineva în interfață, și nu se pretinde că ar fi — e
                      scurtătura către omul care chiar poate apăsa butonul. */}
                  <a href={`mailto:${a.email}?subject=${encodeURIComponent(
                    t("fara_acces.subiect_mail", {
                      proiect: proiect ?? t("fara_acces.proiect_anonim"),
                    }))}`}>
                    {a.email}
                  </a>
                </li>
              ))}
            </ul>
          </>
        )}

        <a className="fara-acces-inapoi" href="/projects">{t("fara_acces.inapoi")}</a>
      </div>
    </div>
  );
}
